import React from "react";
import {
  CardBody as OriginCardBody
} from "reactstrap";
import { getSize } from "../../utils/size";
import { classnames, combinePrefixes } from "../../utils/text";

const CardBody = ({
  type = 'default',
  size = 'md', // lg, md, sm ,x-sm
  className = '',
  ...props
}) => {
  return <OriginCardBody
    className={
      classnames(
        combinePrefixes(`card-body`, [type.toLowerCase(), getSize(size),]),
        className
      )
    }
    {...props}
  />
}
export default CardBody